export default __webpack_public_path__ + "static/carousel-3-marta-a8d0827da46558c2370ea6e1236baf59.png";